import React, { Component } from 'react';
import './App.scss';
import './App.css';
import { ApolloProvider } from "react-apollo";
import BaseLayout from './layouts/BaseLayout'
import client from './store/graphql/index'
import {
  BrowserRouter as Router
} from 'react-router-dom'

class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <Router>
          <BaseLayout />
        </Router>
      </ApolloProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js